<template>
  <button
    type="button"
    class="rounded-full bg-sky-100 px-3 py-1.5 text-center text-sm font-medium leading-4 text-sky-700 transition-colors hover:bg-sky-200"
  >
    <slot />
  </button>
</template>

<script>
// Shared time-slot pill used by SpecialistBookingPanel and ServiceSlotsCalendar
// so desktop and mobile booking UIs stay visually identical.
// Click (and other) listeners fall through to the root <button>.
export default {
  name: 'BookingSlotButton',
};
</script>
